module.exports = __webpack_public_path__ + "static/media/generate.5c189e27.png";